import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator that requires control to have a value. Whitespace is invalid.
 */
export const RequiredValidator = (): ValidatorFn => {
  return (activeControl: AbstractControl): ValidationErrors | null => {
    return (activeControl.value || '').toString().trim().length === 0
      ? { required: activeControl.value }
      : null;
  };
};

/**
 * Validator that requires control to have a value only if it satisfies the passed condition. Whitespace is invalid.
 */
export const RequiredIfValidator = (condition: boolean): ValidatorFn => {
  return (activeControl: AbstractControl): ValidationErrors | null => {
    return condition && (activeControl.value || '').toString().trim().length === 0
      ? { required: activeControl.value }
      : null;
  };
};
